<template>
  <tri60 v-if="valueName == '360'" />
  <add-business v-else-if="valueName == 'add_business'" />
  <add-location v-else-if="valueName == 'add_location'" />
  <add-location-alt v-else-if="valueName == 'add_location_alt'" />
  <add-road v-else-if="valueName == 'add_road'" />
  <agriculture v-else-if="valueName == 'agriculture'" />
  <alt-route v-else-if="valueName == 'alt_route'" />
  <atm v-else-if="valueName == 'atm'" />
  <beenhere v-else-if="valueName == 'beenhere'" />
  <bike-scooter v-else-if="valueName == 'bike_scooter'" />
  <category v-else-if="valueName == 'category'" />
  <cleaning-services v-else-if="valueName == 'cleaning_services'" />
  <compass-calibration v-else-if="valueName == 'compass_calibration'" />
  <departure-board v-else-if="valueName == 'departure_board'" />
  <design-services v-else-if="valueName == 'design_services'" />
  <directions v-else-if="valueName == 'directions'" />
  <directions-bike v-else-if="valueName == 'directions_bike'" />
  <directions-boat v-else-if="valueName == 'directions_boat'" />
  <directions-bus v-else-if="valueName == 'directions_bus'" />
  <directions-car v-else-if="valueName == 'directions_car'" />
  <directions-railway v-else-if="valueName == 'directions_railway'" />
  <directions-run v-else-if="valueName == 'directions_run'" />
  <directions-subway v-else-if="valueName == 'directions_subway'" />
  <directions-transit v-else-if="valueName == 'directions_transit'" />
  <directions-walk v-else-if="valueName == 'directions_walk'" />
  <edit-attributes v-else-if="valueName == 'edit_attributes'" />
  <edit-location v-else-if="valueName == 'edit_location'" />
  <edit-road v-else-if="valueName == 'edit_road'" />
  <electric-bike v-else-if="valueName == 'electric_bike'" />
  <electric-car v-else-if="valueName == 'electric_car'" />
  <electric-moped v-else-if="valueName == 'electric_moped'" />
  <electric-rickshaw v-else-if="valueName == 'electric_rickshaw'" />
  <electric-scooter v-else-if="valueName == 'electric_scooter'" />
  <electrical-services v-else-if="valueName == 'electrical_services'" />
  <ev-station v-else-if="valueName == 'ev_station'" />
  <fastfood v-else-if="valueName == 'fastfood'" />
  <flight v-else-if="valueName == 'flight'" />
  <handyman v-else-if="valueName == 'handyman'" />
  <home-repair-service v-else-if="valueName == 'home_repair_service'" />
  <hotel v-else-if="valueName == 'hotel'" />
  <hvac v-else-if="valueName == 'hvac'" />
  <layers v-else-if="valueName == 'layers'" />
  <layers-clear v-else-if="valueName == 'layers_clear'" />
  <local-activity v-else-if="valueName == 'local_activity'" />
  <local-airport v-else-if="valueName == 'local_airport'" />
  <local-atm v-else-if="valueName == 'local_atm'" />
  <local-bar v-else-if="valueName == 'local_bar'" />
  <local-cafe v-else-if="valueName == 'local_cafe'" />
  <local-car-wash v-else-if="valueName == 'local_car_wash'" />
  <local-convenience-store v-else-if="valueName == 'local_convenience_store'" />
  <local-dining v-else-if="valueName == 'local_dining'" />
  <local-drink v-else-if="valueName == 'local_drink'" />
  <local-fire-department v-else-if="valueName == 'local_fire_department'" />
  <local-florist v-else-if="valueName == 'local_florist'" />
  <local-gas-station v-else-if="valueName == 'local_gas_station'" />
  <local-grocery-store v-else-if="valueName == 'local_grocery_store'" />
  <local-hospital v-else-if="valueName == 'local_hospital'" />
  <local-hotel v-else-if="valueName == 'local_hotel'" />
  <local-laundry-service v-else-if="valueName == 'local_laundry_service'" />
  <local-library v-else-if="valueName == 'local_library'" />
  <local-mall v-else-if="valueName == 'local_mall'" />
  <local-movies v-else-if="valueName == 'local_movies'" />
  <local-offer v-else-if="valueName == 'local_offer'" />
  <local-parking v-else-if="valueName == 'local_parking'" />
  <local-pharmacy v-else-if="valueName == 'local_pharmacy'" />
  <local-phone v-else-if="valueName == 'local_phone'" />
  <local-pizza v-else-if="valueName == 'local_pizza'" />
  <local-play v-else-if="valueName == 'local_play'" />
  <local-police v-else-if="valueName == 'local_police'" />
  <local-post-office v-else-if="valueName == 'local_post_office'" />
  <local-printshop v-else-if="valueName == 'local_printshop'" />
  <local-see v-else-if="valueName == 'local_see'" />
  <local-shipping v-else-if="valueName == 'local_shipping'" />
  <local-taxi v-else-if="valueName == 'local_taxi'" />
  <ic-map v-else-if="valueName == 'map'" />
  <maps-ugc v-else-if="valueName == 'maps_ugc'" />
  <medical-services v-else-if="valueName == 'medical_services'" />
  <menu-book v-else-if="valueName == 'menu_book'" />
  <miscellaneous-services v-else-if="valueName == 'miscellaneous_services'" />
  <money v-else-if="valueName == 'money'" />
  <moped v-else-if="valueName == 'moped'" />
  <multiple-stop v-else-if="valueName == 'multiple_stop'" />
  <museum v-else-if="valueName == 'museum'" />
  <my-location v-else-if="valueName == 'my_location'" />
  <navigation v-else-if="valueName == 'navigation'" />
  <near-me v-else-if="valueName == 'near_me'" />
  <near-me-disabled v-else-if="valueName == 'near_me_disabled'" />
  <no-meals v-else-if="valueName == 'no_meals'" />
  <no-transfer v-else-if="valueName == 'no_transfer'" />
  <not-listed-location v-else-if="valueName == 'not_listed_location'" />
  <pedal-bike v-else-if="valueName == 'pedal_bike'" />
  <person-pin v-else-if="valueName == 'person_pin'" />
  <person-pin-circle v-else-if="valueName == 'person_pin_circle'" />
  <pest-control v-else-if="valueName == 'pest_control'" />
  <pest-control-rodent v-else-if="valueName == 'pest_control_rodent'" />
  <pin-drop v-else-if="valueName == 'pin_drop'" />
  <place v-else-if="valueName == 'place'" />
  <plumbing v-else-if="valueName == 'plumbing'" />
  <rate-review v-else-if="valueName == 'rate_review'" />
  <restaurant v-else-if="valueName == 'restaurant'" />
  <restaurant-menu v-else-if="valueName == 'restaurant_menu'" />
  <run-circle v-else-if="valueName == 'run_circle'" />
  <satellite v-else-if="valueName == 'satellite'" />
  <set-meal v-else-if="valueName == 'set_meal'" />
  <store-mall-directory v-else-if="valueName == 'store_mall_directory'" />
  <streetview v-else-if="valueName == 'streetview'" />
  <subway v-else-if="valueName == 'subway'" />
  <terrain v-else-if="valueName == 'terrain'" />
  <traffic v-else-if="valueName == 'traffic'" />
  <train v-else-if="valueName == 'train'" />
  <tram v-else-if="valueName == 'tram'" />
  <transfer-within-a-station
    v-else-if="valueName == 'transfer_within_a_station'"
  />
  <transit-enterexit v-else-if="valueName == 'transit_enterexit'" />
  <trip-origin v-else-if="valueName == 'trip_origin'" />
  <two-wheeler v-else-if="valueName == 'two_wheeler'" />
  <wine-bar v-else-if="valueName == 'wine_bar'" />
  <wrong-location v-else-if="valueName == 'wrong_location'" />
  <zoom-out-map v-else-if="valueName == 'zoom_out_map'" />
</template>

<script>
import Tri60 from "@/components/Icons/Maps/Tri60";
import AddBusiness from "@/components/Icons/Maps/AddBusiness";
import AddLocation from "@/components/Icons/Maps/AddLocation";
import AddLocationAlt from "@/components/Icons/Maps/AddLocationAlt";
import AddRoad from "@/components/Icons/Maps/AddRoad";
import Agriculture from "@/components/Icons/Maps/Agriculture";
import AltRoute from "@/components/Icons/Maps/AltRoute";
import Atm from "@/components/Icons/Maps/Atm";
import Beenhere from "@/components/Icons/Maps/Beenhere";
import BikeScooter from "@/components/Icons/Maps/BikeScooter";
import Category from "@/components/Icons/Maps/Category";
import CleaningServices from "@/components/Icons/Maps/CleaningServices";
import CompassCalibration from "@/components/Icons/Maps/CompassCalibration";
import DepartureBoard from "@/components/Icons/Maps/DepartureBoard";
import DesignServices from "@/components/Icons/Maps/DesignServices";
import Directions from "@/components/Icons/Maps/Directions";
import DirectionsBike from "@/components/Icons/Maps/DirectionsBike";
import DirectionsBoat from "@/components/Icons/Maps/DirectionsBoat";
import DirectionsBus from "@/components/Icons/Maps/DirectionsBus";
import DirectionsCar from "@/components/Icons/Maps/DirectionsCar";
import DirectionsRailway from "@/components/Icons/Maps/DirectionsRailway";
import DirectionsRun from "@/components/Icons/Maps/DirectionsRun";
import DirectionsSubway from "@/components/Icons/Maps/DirectionsSubway";
import DirectionsTransit from "@/components/Icons/Maps/DirectionsTransit";
import DirectionsWalk from "@/components/Icons/Maps/DirectionsWalk";
import EditAttributes from "@/components/Icons/Maps/EditAttributes";
import EditLocation from "@/components/Icons/Maps/EditLocation";
import EditRoad from "@/components/Icons/Maps/EditRoad";
import ElectricBike from "@/components/Icons/Maps/ElectricBike";
import ElectricCar from "@/components/Icons/Maps/ElectricCar";
import ElectricMoped from "@/components/Icons/Maps/ElectricMoped";
import ElectricRickshaw from "@/components/Icons/Maps/ElectricRickshaw";
import ElectricScooter from "@/components/Icons/Maps/ElectricScooter";
import ElectricalServices from "@/components/Icons/Maps/ElectricalServices";
import EvStation from "@/components/Icons/Maps/EvStation";
import Fastfood from "@/components/Icons/Maps/Fastfood";
import Flight from "@/components/Icons/Maps/Flight";
import Handyman from "@/components/Icons/Maps/Handyman";
import HomeRepairService from "@/components/Icons/Maps/HomeRepairService";
import Hotel from "@/components/Icons/Maps/Hotel";
import Hvac from "@/components/Icons/Maps/Hvac";
import Layers from "@/components/Icons/Maps/Layers";
import LayersClear from "@/components/Icons/Maps/LayersClear";
import LocalActivity from "@/components/Icons/Maps/LocalActivity";
import LocalAirport from "@/components/Icons/Maps/LocalAirport";
import LocalAtm from "@/components/Icons/Maps/LocalAtm";
import LocalBar from "@/components/Icons/Maps/LocalBar";
import LocalCafe from "@/components/Icons/Maps/LocalCafe";
import LocalCarWash from "@/components/Icons/Maps/LocalCarWash";
import LocalConvenienceStore from "@/components/Icons/Maps/LocalConvenienceStore";
import LocalDining from "@/components/Icons/Maps/LocalDining";
import LocalDrink from "@/components/Icons/Maps/LocalDrink";
import LocalFireDepartment from "@/components/Icons/Maps/LocalFireDepartment";
import LocalFlorist from "@/components/Icons/Maps/LocalFlorist";
import LocalGasStation from "@/components/Icons/Maps/LocalGasStation";
import LocalGroceryStore from "@/components/Icons/Maps/LocalGroceryStore";
import LocalHospital from "@/components/Icons/Maps/LocalHospital";
import LocalHotel from "@/components/Icons/Maps/LocalHotel";
import LocalLaundryService from "@/components/Icons/Maps/LocalLaundryService";
import LocalLibrary from "@/components/Icons/Maps/LocalLibrary";
import LocalMall from "@/components/Icons/Maps/LocalMall";
import LocalMovies from "@/components/Icons/Maps/LocalMovies";
import LocalOffer from "@/components/Icons/Maps/LocalOffer";
import LocalParking from "@/components/Icons/Maps/LocalParking";
import LocalPharmacy from "@/components/Icons/Maps/LocalPharmacy";
import LocalPhone from "@/components/Icons/Maps/LocalPhone";
import LocalPizza from "@/components/Icons/Maps/LocalPizza";
import LocalPlay from "@/components/Icons/Maps/LocalPlay";
import LocalPolice from "@/components/Icons/Maps/LocalPolice";
import LocalPostOffice from "@/components/Icons/Maps/LocalPostOffice";
import LocalPrintshop from "@/components/Icons/Maps/LocalPrintshop";
import LocalSee from "@/components/Icons/Maps/LocalSee";
import LocalShipping from "@/components/Icons/Maps/LocalShipping";
import LocalTaxi from "@/components/Icons/Maps/LocalTaxi";
import IcMap from "@/components/Icons/Maps/IcMap";
import MapsUgc from "@/components/Icons/Maps/MapsUgc";
import MedicalServices from "@/components/Icons/Maps/MedicalServices";
import MenuBook from "@/components/Icons/Maps/MenuBook";
import MiscellaneousServices from "@/components/Icons/Maps/MiscellaneousServices";
import Money from "@/components/Icons/Maps/Money";
import Moped from "@/components/Icons/Maps/Moped";
import MultipleStop from "@/components/Icons/Maps/MultipleStop";
import Museum from "@/components/Icons/Maps/Museum";
import MyLocation from "@/components/Icons/Maps/MyLocation";
import Navigation from "@/components/Icons/Maps/Navigation";
import NearMe from "@/components/Icons/Maps/NearMe";
import NearMeDisabled from "@/components/Icons/Maps/NearMeDisabled";
import NoMeals from "@/components/Icons/Maps/NoMeals";
import NoTransfer from "@/components/Icons/Maps/NoTransfer";
import NotListedLocation from "@/components/Icons/Maps/NotListedLocation";
import PedalBike from "@/components/Icons/Maps/PedalBike";
import PersonPin from "@/components/Icons/Maps/PersonPin";
import PersonPinCircle from "@/components/Icons/Maps/PersonPinCircle";
import PestControl from "@/components/Icons/Maps/PestControl";
import PestControlRodent from "@/components/Icons/Maps/PestControlRodent";
import PinDrop from "@/components/Icons/Maps/PinDrop";
import Place from "@/components/Icons/Maps/Place";
import Plumbing from "@/components/Icons/Maps/Plumbing";
import RateReview from "@/components/Icons/Maps/RateReview";
import Restaurant from "@/components/Icons/Maps/Restaurant";
import RestaurantMenu from "@/components/Icons/Maps/RestaurantMenu";
import RunCircle from "@/components/Icons/Maps/RunCircle";
import Satellite from "@/components/Icons/Maps/Satellite";
import SetMeal from "@/components/Icons/Maps/SetMeal";
import StoreMallDirectory from "@/components/Icons/Maps/StoreMallDirectory";
import Streetview from "@/components/Icons/Maps/Streetview";
import Subway from "@/components/Icons/Maps/Subway";
import Terrain from "@/components/Icons/Maps/Terrain";
import Traffic from "@/components/Icons/Maps/Traffic";
import Train from "@/components/Icons/Maps/Train";
import Tram from "@/components/Icons/Maps/Tram";
import TransferWithinAStation from "@/components/Icons/Maps/TransferWithinAStation";
import TransitEnterexit from "@/components/Icons/Maps/TransitEnterexit";
import TripOrigin from "@/components/Icons/Maps/TripOrigin";
import TwoWheeler from "@/components/Icons/Maps/TwoWheeler";
import WineBar from "@/components/Icons/Maps/WineBar";
import WrongLocation from "@/components/Icons/Maps/WrongLocation";
import ZoomOutMap from "@/components/Icons/Maps/ZoomOutMap";

export default {
  components: {
    Tri60,
    AddBusiness,
    AddLocation,
    AddLocationAlt,
    AddRoad,
    Agriculture,
    AltRoute,
    Atm,
    Beenhere,
    BikeScooter,
    Category,
    CleaningServices,
    CompassCalibration,
    DepartureBoard,
    DesignServices,
    Directions,
    DirectionsBike,
    DirectionsBoat,
    DirectionsBus,
    DirectionsCar,
    DirectionsRailway,
    DirectionsRun,
    DirectionsSubway,
    DirectionsTransit,
    DirectionsWalk,
    EditAttributes,
    EditLocation,
    EditRoad,
    ElectricBike,
    ElectricCar,
    ElectricMoped,
    ElectricRickshaw,
    ElectricScooter,
    ElectricalServices,
    EvStation,
    Fastfood,
    Flight,
    Handyman,
    HomeRepairService,
    Hotel,
    Hvac,
    Layers,
    LayersClear,
    LocalActivity,
    LocalAirport,
    LocalAtm,
    LocalBar,
    LocalCafe,
    LocalCarWash,
    LocalConvenienceStore,
    LocalDining,
    LocalDrink,
    LocalFireDepartment,
    LocalFlorist,
    LocalGasStation,
    LocalGroceryStore,
    LocalHospital,
    LocalHotel,
    LocalLaundryService,
    LocalLibrary,
    LocalMall,
    LocalMovies,
    LocalOffer,
    LocalParking,
    LocalPharmacy,
    LocalPhone,
    LocalPizza,
    LocalPlay,
    LocalPolice,
    LocalPostOffice,
    LocalPrintshop,
    LocalSee,
    LocalShipping,
    LocalTaxi,
    IcMap,
    MapsUgc,
    MedicalServices,
    MenuBook,
    MiscellaneousServices,
    Money,
    Moped,
    MultipleStop,
    Museum,
    MyLocation,
    Navigation,
    NearMe,
    NearMeDisabled,
    NoMeals,
    NoTransfer,
    NotListedLocation,
    PedalBike,
    PersonPin,
    PersonPinCircle,
    PestControl,
    PestControlRodent,
    PinDrop,
    Place,
    Plumbing,
    RateReview,
    Restaurant,
    RestaurantMenu,
    RunCircle,
    Satellite,
    SetMeal,
    StoreMallDirectory,
    Streetview,
    Subway,
    Terrain,
    Traffic,
    Train,
    Tram,
    TransferWithinAStation,
    TransitEnterexit,
    TripOrigin,
    TwoWheeler,
    WineBar,
    WrongLocation,
    ZoomOutMap,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
